export default __webpack_public_path__ + "static/media/leader-star.3d57a626.svg";